export default __webpack_public_path__ + "static/media/sample.5d300df0.pdf";